export enum Experiment {
  MoveJoinCommunityCTA = 'specs.profileCardOOI.JoinCommunityCTAUnderMoreActions',
  MakeProfileCardRemovableInNewMA = 'specs.profileCardOOI.MakeProfileCardRemovableInNewMA',
  EnableCSSIndicators = 'specs.profileCardOOI.EnableCSSIndicators',
  EnableAvifEncoding = 'specs.profileCardOOI.EnableAvifEncoding',
  ShowNewNotificationsContent = 'specs.profileCardOOI.showNewNotificationsContent',
  UsePlaceholderLoaders = 'specs.profileCardOOI.usePlaceholderLoaders',
}
